var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebinar105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53 82.5C53 82.2239 52.7761 82 52.5 82C52.2239 82 52 82.2239 52 82.5V90H28.5C28.2239 90 28 90.2239 28 90.5C28 90.7761 28.2239 91 28.5 91H52.5H76.5C76.7761 91 77 90.7761 77 90.5C77 90.2239 76.7761 90 76.5 90H53V82.5Z",
  fill: "var(--icon-decorative-coral)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 14.5C8 14.2239 8.22386 14 8.5 14H96.5C96.7761 14 97 14.2239 97 14.5V72.5C97 72.7761 96.7761 73 96.5 73H8.5C8.22386 73 8 72.7761 8 72.5V14.5ZM9 15V72H96V15H9Z",
  fill: "currentColor"
})));
export default SvgWebinar105;